import { HeadshotProps, HeadshotTypes } from '../Headshot/headshot.types';

export interface PlayerSpotProps extends HeadshotProps {
  src: string;
}

export enum SpotType {
  LEAGUE = 'league',
  PLAYER = 'player',
  SPORT = 'sport',
  TEAM = 'team',
}

export interface SpotProps {
  alt: string;
  className?: string;
  id: string | number;
  isFavorite?: boolean;
  lazyload?: boolean;
  spotSource?: HeadshotTypes;
  type: SpotType;
  width: string | number;
}
